import { inject } from "@angular/core";
import { CanActivateFn } from "@angular/router";
import { ToastService } from "@app/services";
import { StateStatus } from "@app/state/model";
import { selectChecklistsStatus } from "@app/state/selectors";
import { Store } from "@ngrx/store";
import { filter, map, take, tap } from "rxjs";

export const checklistGuard: CanActivateFn = () => {
  const store = inject(Store);
  const toast = inject(ToastService);
  return store.select(selectChecklistsStatus).pipe(
    tap((status) => {
      switch (status) {
        case StateStatus.Pending:
          toast.show("Checklists pending to load...");
          break;
        case StateStatus.Loading:
          toast.show("Checklists loading...");
          break;
        case StateStatus.Error:
          toast.show("Checklists failed to load...");
          break;
      }
    }),
    filter(
      (status) =>
        status === StateStatus.Success || status === StateStatus.Error
    ),
    map((status) => status === StateStatus.Success),
    take(1)
  );
};
